import { useSelector, useDispatch, TypedUseSelectorHook } from "react-redux"
import type { RootState, AppDispatch } from "../store/Store"

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()